import type { ProductWeight } from '@iheartjane/types';

export const PRICE_ID_TO_GRAMS: Record<ProductWeight, number> = {
  half_gram: 0.5,
  gram: 1.0,
  two_gram: 2.0,
  eighth_ounce: 3.5,
  quarter_ounce: 7,
  half_ounce: 14,
  ounce: 28,
};

export const PRICE_ID_TO_MILLIGRAMS: Record<ProductWeight, number> = {
  half_gram: 500,
  gram: 1000,
  two_gram: 2000,
  eighth_ounce: 3500,
  quarter_ounce: 7000,
  half_ounce: 14000,
  ounce: 28000,
};
